module.exports = __webpack_public_path__ + "media/images/front/icons/timeline-5dff080670be9d54e1aa32beda041ee9.png";